import React, { Fragment } from 'react';

import Accordion from 'components/Accordion/Accordion';
import AccordionItem from 'components/Accordion/AccordionItem/AccordionItem';

import styles from './accordionsLayouts.css';

/* eslint-disable react/prop-types */
export const primaryLayout = ({
  bgGrey = false,
  infoSection = [{label: 'Label', text: 'Max-width: 176px'}]
}) => (
  <div className={styles.componentWrapper}>
    <Accordion>
      <AccordionItem
        className="main-content"
        title="Title Section"
        bgGrey={bgGrey}
        infoSection={infoSection}
      >
        <Fragment></Fragment>
      </AccordionItem>
    </Accordion>
  </div>
);

export const secondaryLayout = ({
  bgGrey = false,
  infoSection = [{label: '(LABEL) JUSTO NEC ULTRICES DUI', text: 'Rs. 00,000,000.00'}]
}) => (
  <div className={styles.componentWrapper}>
    <Accordion>
      <AccordionItem
        secondary
        className="main-content"
        title={{ name: 'Title lorumi', info: 'information', counter: '000'}}
        bgGrey={bgGrey}
        infoSection={infoSection}
      >
        <Fragment></Fragment>
      </AccordionItem>
    </Accordion>
  </div>
);

export const reducedSpacesLayout = ({ bgGrey = false }) => (
  <div className={`${styles.componentWrapper} ${styles.reducedSpaces}`}>
    <Accordion>
      <AccordionItem
        reducedSpaces
        className="main-content"
        title="TITLE - MAX-WIDTH 200PX"
        bgGrey={bgGrey}
      >
        <Fragment></Fragment>
      </AccordionItem>
    </Accordion>
  </div>
);
/* eslint-enable react/prop-types */



// WEBPACK FOOTER //
// ./src/containers/components/Accordion/constants/accordionsLayouts.js